module.exports = __webpack_public_path__ + "img/luna.18d8fb9f.svg";